export default (props) => {
    return new Date(props.value).toLocaleString()
}
